import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { areaColor } from "../../../config/enum";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
/* import DataTable from "examples/Tables/DataTable"; */

import CreateEditOrder from "../../../customComponents/devicesComponents/CreateEditOrder";
import DeleteModal from "../../../customComponents/devicesComponents/DeleteModal";

import { getOrder, deleteOrder } from "../../../api/orders";
import { setCurrentOrder } from "../../../redux/reducers/ordersReducer";

import { getDevice } from "../../../api/devices";
import { setCurrentDevices } from "../../../redux/reducers/devicesReducer";

import { useDispatch, useSelector } from "react-redux";

import AllDevicesAccordion from "../../../customComponents/devicesComponents/AllDevicesAccordion";
import OrderComs from "./OrderComs";
import OrderStages from "./OrderStages";
import OrderCostingTable from "./OrderCostingTable";

import CreateEditDevice from "../../../customComponents/devicesComponents/CreateEditDevice";

import { useNavigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import { canEditOrder } from "../../../utils/permissions";

export default function Order() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [authorized, setAuthorized] = useState(false);

  const orderId = useLocation().pathname.split("/")[2];

  const dispatch = useDispatch();

  const currentOrder = useSelector((state) => state.orders.currentOrder);

  async function fetchOrder() {
    const response = await getOrder(orderId);
    dispatch(setCurrentOrder(response.data));
  }

  async function fetchDevice(deviceId) {
    const response = await getDevice(deviceId);
    return await response.data;
  }

  useEffect(() => {
    if (orderId) fetchOrder();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);

  const getDevices = async () => {
    if (currentOrder) {
      if (currentOrder.devices_ids) {
        const devices = [];
        const devices_id = currentOrder.devices_ids.split(",");
        for (let i = 0; i < devices_id.length; i++) {
          devices.push(await fetchDevice(devices_id[i]));
        }

        // Sort the devices array based on the device identifier
        devices.sort((a, b) => {
          // Extract the base device identifier (ignoring anything after a hyphen)
          const baseIdA = a.device_number.split(" -")[0];
          const baseIdB = b.device_number.split(" -")[0];

          // Compare the base identifiers
          if (baseIdA < baseIdB) return -1;
          if (baseIdA > baseIdB) return 1;

          // If base identifiers are equal, compare the full device_id to maintain relative order
          return a.device_number.localeCompare(b.device_number);
        });

        dispatch(setCurrentDevices(devices));
      }
    }
  };

  useEffect(() => {
    if (user && currentOrder) {
      // Tous les contremaîtres peuvent désormais consulter n'importe quelle
      // affaire (lecture seule sur les chantiers qui ne sont pas les leurs).
      // Les droits d'édition sont gérés en aval via canEditOrder().
      if (
        user.role === "Admin" ||
        user.role === "Pilote" ||
        user.role === "Assistante de gestion" ||
        user.role === "Direction" ||
        user.role === "Contremaître" ||
        user.role === "Commercial" ||
        (user.role === "Chef d'agence" &&
          user.user_areas &&
          user.user_areas.includes(currentOrder.area))
      ) {
        setAuthorized(true);
        getDevices();
      } else {
        navigate("/accueil");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrder, user]);

  const orderColumns = [
    { Header: "Commercial projet", accessor: "responsible_business", align: "center" },
    { Header: "Commercial service", accessor: "salesman", align: "center" },
    { Header: "Contremaître", accessor: "foreman", align: "center" },
    { Header: "Assistante de gestion", accessor: "managassist", align: "center" },
    { Header: "Maître d'ouvrage", accessor: "building_owner", align: "center" },
    { Header: "Maître d'oeuvre", accessor: "project_manager", align: "center" },
    { Header: "Type de travaux", accessor: "work_type", align: "center" },
    { Header: "Nom du chantier", accessor: "site_name", align: "center" },
    { Header: "Ville", accessor: "city", align: "center" },
    { Header: "Zone géographique", accessor: "area", align: "center" },
  ];
  const orderRows = [
    {
      responsible_business: (
        <>
          {currentOrder && currentOrder.responsible_business_name ? (
            <MDBox display="flex" alignItems="center" lineHeight={1}>
              <MDBox lineHeight={1}>
                {currentOrder && currentOrder.responsible_business_name && (
                  <MDTypography display="block" variant="button" fontWeight="medium">
                    {currentOrder.responsible_business_name}
                  </MDTypography>
                )}
                {/* {currentOrder && currentOrder.responsible_business_email && (
                  <MDTypography variant="caption">
                    {currentOrder.responsible_business_email}
                  </MDTypography>
                )}
                <br />
                {currentOrder && currentOrder.responsible_business_phone && (
                  <MDTypography variant="caption">
                    {currentOrder.responsible_business_phone}
                  </MDTypography>
                )} */}
              </MDBox>
            </MDBox>
          ) : (
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
              <MDTypography display="block" variant="caption" color="warning" fontWeight="medium">
                Non spécifié
              </MDTypography>
            </MDBox>
          )}
        </>
      ),
      salesman: (
        <>
          {currentOrder && currentOrder.salesman_name ? (
            <MDBox display="flex" alignItems="center" lineHeight={1}>
              <MDBox lineHeight={1}>
                {currentOrder && currentOrder.salesman_name && (
                  <MDTypography display="block" variant="button" fontWeight="medium">
                    {currentOrder.salesman_name}
                  </MDTypography>
                )}
                {/* {currentOrder && currentOrder.salesman_email && (
                  <MDTypography variant="caption">{currentOrder.salesman_email}</MDTypography>
                )}
                <br />
                {currentOrder && currentOrder.salesman_phone && (
                  <MDTypography variant="caption">{currentOrder.salesman_phone}</MDTypography>
                )} */}
              </MDBox>
            </MDBox>
          ) : (
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
              <MDTypography display="block" variant="caption" color="warning" fontWeight="medium">
                Non spécifié
              </MDTypography>
            </MDBox>
          )}
        </>
      ),
      building_owner: (
        <MDBox display="flex" alignItems="center" lineHeight={1}>
          {currentOrder && currentOrder.building_owner ? (
            <MDBox lineHeight={1}>
              <MDTypography display="block" variant="button" fontWeight="medium">
                {currentOrder.building_owner}
              </MDTypography>
            </MDBox>
          ) : (
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
              <MDTypography display="block" variant="caption" color="warning" fontWeight="medium">
                Non spécifié
              </MDTypography>
            </MDBox>
          )}
        </MDBox>
      ),
      managassist: (
        <>
          {currentOrder && currentOrder.management_assistant_name ? (
            <MDBox display="flex" alignItems="center" lineHeight={1}>
              <MDBox lineHeight={1}>
                {currentOrder && currentOrder.management_assistant_name && (
                  <MDTypography display="block" variant="button" fontWeight="medium">
                    {currentOrder.management_assistant_name}
                  </MDTypography>
                )}
                {/* {currentOrder && currentOrder.foreman_email && (
                  <MDTypography variant="caption">{currentOrder.foreman_email}</MDTypography>
                )}
                <br />
                {currentOrder && currentOrder.foreman_phone && (
                  <MDTypography variant="caption">{currentOrder.foreman_phone}</MDTypography>
                )} */}
              </MDBox>
            </MDBox>
          ) : (
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
              <MDTypography display="block" variant="caption" color="warning" fontWeight="medium">
                Non spécifiée
              </MDTypography>
            </MDBox>
          )}
        </>
      ),
      foreman: (
        <>
          {currentOrder && currentOrder.foreman_name ? (
            <MDBox display="flex" alignItems="center" lineHeight={1}>
              <MDBox lineHeight={1}>
                {currentOrder && currentOrder.foreman_name && (
                  <MDTypography display="block" variant="button" fontWeight="medium">
                    {currentOrder.foreman_name}
                  </MDTypography>
                )}
                {/* {currentOrder && currentOrder.foreman_email && (
                  <MDTypography variant="caption">{currentOrder.foreman_email}</MDTypography>
                )}
                <br />
                {currentOrder && currentOrder.foreman_phone && (
                  <MDTypography variant="caption">{currentOrder.foreman_phone}</MDTypography>
                )} */}
              </MDBox>
            </MDBox>
          ) : (
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
              <MDTypography display="block" variant="caption" color="warning" fontWeight="medium">
                Non spécifié
              </MDTypography>
            </MDBox>
          )}
        </>
      ),
      project_manager: (
        <MDBox display="flex" alignItems="center" lineHeight={1}>
          {currentOrder && currentOrder.project_manager ? (
            <MDBox lineHeight={1}>
              <MDTypography display="block" variant="button" fontWeight="medium">
                {currentOrder.project_manager}
              </MDTypography>
            </MDBox>
          ) : (
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
              <MDTypography display="block" variant="caption" color="warning" fontWeight="medium">
                Non spécifié
              </MDTypography>
            </MDBox>
          )}
        </MDBox>
      ),
      area: (
        <>
          {currentOrder && currentOrder.area ? (
            <MDTypography component="a" variant="button" fontWeight="medium">
              {currentOrder.area}
            </MDTypography>
          ) : (
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
              <MDTypography display="block" variant="caption" color="warning" fontWeight="medium">
                Non spécifiée
              </MDTypography>
            </MDBox>
          )}
        </>
      ),
      city: (
        <>
          {currentOrder && currentOrder.city ? (
            <MDTypography component="a" variant="button" fontWeight="medium">
              {currentOrder.city}
            </MDTypography>
          ) : (
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
              <MDTypography display="block" variant="caption" color="warning" fontWeight="medium">
                Non spécifiée
              </MDTypography>
            </MDBox>
          )}
        </>
      ),
      site_name: (
        <>
          {currentOrder && currentOrder.site_name ? (
            <MDTypography component="a" variant="button" fontWeight="medium">
              {currentOrder.site_name}
            </MDTypography>
          ) : (
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
              <MDTypography display="block" variant="caption" color="warning" fontWeight="medium">
                Non spécifié
              </MDTypography>
            </MDBox>
          )}
        </>
      ),
      work_type: (
        <>
          {currentOrder && currentOrder.work_type ? (
            <MDTypography component="a" variant="button" fontWeight="medium">
              {currentOrder.work_type}
            </MDTypography>
          ) : (
            <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
              <MDTypography display="block" variant="caption" color="warning" fontWeight="medium">
                Non spécifié
              </MDTypography>
            </MDBox>
          )}
        </>
      ),
    },
  ];

  return (
    <DashboardLayout>
      {user && authorized && (
        <>
          <DashboardNavbar />
          <MDBox pt={3} pb={1.5}>
            <Grid item xs={12} mt={5} mb={3}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={1.5}
                  px={2}
                  variant="gradient"
                  borderRadius="lg"
                  sx={{
                    backgroundColor: currentOrder && areaColor[currentOrder.area],
                    boxShadow: `0 1px 6px 1px ${currentOrder && areaColor[currentOrder.area]}`,
                    display: "flex",
                    verticalAlign: "middle",
                  }}
                >
                  <MDTypography
                    variant="h5"
                    sx={{
                      width: "50%",
                      lineHeight: "2.4rem",
                      display: "tableCell",
                      verticalAlign: "middle",
                    }}
                    color="white"
                  >
                    Commande {currentOrder && currentOrder.order_number}
                  </MDTypography>
                  {canEditOrder(user, currentOrder) && (
                      <Grid sx={{ textAlign: "right", width: "50%" }}>
                        <CreateEditDevice edit={false} />
                        <CreateEditOrder edit={true} />
                        <DeleteModal
                          message={`la commande ${currentOrder && currentOrder.order_number}`}
                          onOk={() => {
                            deleteOrder(orderId);
                            dispatch(setCurrentOrder(null));
                          }}
                          redirect="/commandes"
                        />
                      </Grid>
                    )}
                </MDBox>
                <MDBox pt={0.75}>
                  <DataTable
                    table={{ columns: orderColumns, rows: orderRows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                </MDBox>
              </Card>
            </Grid>
            <OrderCostingTable />
            {/* {currentOrder &&
          currentOrder.devices_numbers &&
          currentOrder.devices_numbers.includes(",") && <OrderStages />} */}
            <OrderComs user={user && user} />
            <AllDevicesAccordion user={user && user} />
          </MDBox>
        </>
      )}
    </DashboardLayout>
  );
}
